import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { RouteComponentProps } from "react-router"
import { ContactDto } from "."
import IntlProps from "../../helpers/IntlProps"
import { TYPE_CUSTOMER_TAG } from "../../label/labelTypes"

export const initialContactForm = {
    advancedForm: false,
    contactId:  "",
    contactTitle:  "",
    contactFirstName: "",
    contactLastName: "",
    contactName:  "",
    contactEmail:  "",
    contactPrimaryPhoneNumber:  "",
    contactPrimaryPhoneNumberExtension:  "",
    contactPhoneNumberMobile:  "",
    contactLanguage: "",
    contactNotes: "",
    address: {
        addressId: "",
        street: "",
        street2:  "",
        city: "",
        postalCode:  "",
        state: "",
        stateCode:  "",
        country:  "",
        countryCode: "",
    },
    contactDeletedAt: "",
    companyIdentifier:  "",
    taxId:  "",
    addressOnly:  false,
    labelIds: [],
    emailKeyword: [],
    phoneNumberKeywordCheckDup:[],
    playerTypeId: [],
    primaryContactId:"",
    customerTypeId:  "",
    taxNumber:  "",
}

export const getFormFromContact = (contact, addressOnly) => {
    const form= {
        advancedForm: contact?.id !== "",
        contactId: contact?.id ?? "",
        contactTitle: contact?.title ?? "",
        contactFirstName: "",
        contactLastName: "",
        contactName: contact?.name ?? "",
        contactEmail: contact?.email ?? "",
        contactPrimaryPhoneNumber: contact?.phoneNumbers.find(p => p.type == "primary")?.phoneNumber ?? "",
        contactPrimaryPhoneNumberExtension: contact?.phoneNumbers.find(p => p.type == "primary")?.extension ?? "",
        contactPhoneNumberMobile: contact?.phoneNumbers.find(p => p.type == "mobile")?.phoneNumber ?? "",
        contactLanguage: contact?.language || AppContext.getLocale().getLanguage(),
        contactNotes: contact?.notes ?? "",
        address: {
            addressId: contact?.address?.id ?? "",
            street: contact?.address?.street ?? "",
            street2: contact?.address?.street2 ?? "",
            city: contact?.address?.city ?? "",
            postalCode: contact?.address?.postalCode ?? "",
            state: contact?.address?.state ?? "",
            stateCode: contact?.address?.stateCode ?? "",
            country: contact?.address?.country ?? "",
            countryCode: contact?.address?.countryCode ?? "",
        },
        contactDeletedAt: contact?.deletedAt ?? "",
        companyIdentifier: contact?.organizationId ?? "",
        taxId: contact?.taxId ?? "",
        addressOnly: addressOnly ?? false,
        labelIds: contact?.labelIds ?? [],
        emailKeyword: [],
        phoneNumberKeywordCheckDup:[],
        playerTypeId: contact?.labels.filter(l => l.attributes.type === TYPE_CUSTOMER_TAG).map(l => l.id) ?? [],
        customerTypeId: contact?.labels.filter(l => l.attributes.type === "customer-type").map(l => l.id)[0] ?? "",
        taxNumber: contact?.taxNumber ?? "",
    }
    return form
}

export type PathParamsType = {
    supplierId: string,
}

export type PropsType = RouteComponentProps<PathParamsType> & IntlProps & {
    supplierId: string,
}

export type ContactForm={
    advancedForm: boolean
    contactId: string
    contactTitle: string
    contactFirstName: string
    contactName:string
    contactLastName: string
    contactEmail: string
    contactPrimaryPhoneNumber: string
    contactPrimaryPhoneNumberExtension: string
    contactPhoneNumberMobile: string
    contactLanguage: string
    contactNotes: string
    address: {
        addressId: string
        street: string
        street2: string
        city: string
        postalCode: string
        state: string
        stateCode: string
        country: string
        countryCode: string
    },
    contactDeletedAt: string
    companyIdentifier: string
    taxId: string
    addressOnly: boolean
    labelIds: string[]
    playerTypeId: string[]
    customerTypeId: string
    phoneNumberKeywordCheckDup:string[]
    emailKeyword:string[],
    taxNumber: string
}

export type SupplierFormProps={
    companyIdentifier: string 
    contact?:ContactDto
    contactId: string 
    addressOnly:boolean
    cancelRedirectPath: string 
    saveRedirectPath: string
    deleteCallback:()=>void
    upsertCallback:(contactForm:ContactForm)=>void
}

export const HEADER_KEYS = ["supplier_name", "city", "phone_number", "created_at"]


// WEBPACK FOOTER //
// ./src/state/contact/models/types.ts